import { fmtOdds, useOddsFormat } from "@/lib/odds";

// Display-only conversion. The canonical decimal price is always what's stored and used for P&L.
export function Odds({ value, className = "", testid }) {
  const { format } = useOddsFormat();
  return <span className={className} data-testid={testid} title={format === "decimal" ? undefined : `Decimal ${Number(value).toFixed(2)}`}>{fmtOdds(value, format)}</span>;
}

export default Odds;
